import React, { PropsWithChildren } from 'react';
import Modal from 'react-modal';
import { FontWeightType, HeadingLarge } from '../../Text';
import { marryInfoComPolicyHtml, privatePolicyHtml, qnaPolicyHtml } from './policyHtml';
import { useMobile } from '../../../hook/usePlatform';

interface PolicyModalType {
  visible:boolean,
  setVisible(visible:boolean):void,
  title:string,
}

const PolicyModal: React.FC<PropsWithChildren<PolicyModalType>> = (props) => {
  const isMobile = useMobile();
  const {
    visible, setVisible, title, children,
  } = props;
  return (
    <Modal
      isOpen={visible}
      style={{
        overlay: {
          zIndex: 9999,
          backgroundColor: 'rgba(0,0,0,0.5)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        },
        content: {
          border: '',
          backgroundColor: 'transparent',
        },
      }}
      onRequestClose={() => {
        setVisible(false);
      }}
    >
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          height: '100%',
          width: '100%',
          justifyContent: 'center',
        }}
      >

        <div style={{
          width: isMobile ? '100%' : '70%',
          backgroundColor: 'white',
          height: '100%',
        }}
        >
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              position: 'relative',
              marginBottom: 16,
            }}
          >
            <HeadingLarge
              style={{ fontFamily: 'inter', marginTop: 32 }}
              fontWeight={FontWeightType.w800}
            >

              {title}
            </HeadingLarge>
            {isMobile
                  && (
                  <div
                    style={{
                      position: 'absolute',
                      top: 32,
                      right: 16,
                    }}
                    onClick={() => setVisible(false)}
                  >
                    <img
                      width={32}
                      height={32}
                      alt="modal_close"
                      style={{ cursor: 'pointer' }}
                      src="/svg/close_black.svg"
                    />
                  </div>
                  )}
          </div>
          <div style={{
            flex: 1,
            width: '100%',
            height: '100%',
            overflowY: 'auto',
            padding: 16,
          }}
          >
            {children}
          </div>
        </div>
        {!isMobile && (
        <div onClick={() => setVisible(false)}>
          <img
            alt="modal_close"
            style={{ cursor: 'pointer' }}
            src="/svg/close.svg"
          />
        </div>
        )}
      </div>
    </Modal>
  );
};

interface ModalType {
  visible: boolean,

  setVisible(visible: boolean): void,
}

// eslint-disable-next-line react/prop-types
const RenderHtml = ({ tag = 'div', htmlString = '' }) => React.createElement(tag, { dangerouslySetInnerHTML: { __html: htmlString } });

export const MarryInfoPolicyModal : React.FC<ModalType> = (props) => {
  const { visible, setVisible } = props;
  return (
    <PolicyModal
      visible={visible}
      setVisible={setVisible}
      title="국내결혼중개 약관"
    >
      <RenderHtml tag="table" htmlString={marryInfoComPolicyHtml} />
    </PolicyModal>
  );
};

export const PrivatePolicyModal : React.FC<ModalType> = (props) => {
  const { visible, setVisible } = props;
  return (
    <PolicyModal
      visible={visible}
      setVisible={setVisible}
      title="개인정보처리방침"
    >
      <RenderHtml htmlString={privatePolicyHtml} />
    </PolicyModal>
  );
};

export const QnAPolicyModal : React.FC<ModalType> = (props) => {
  const { visible, setVisible } = props;
  return (
    <PolicyModal
      visible={visible}
      setVisible={setVisible}
      title="개인정보처리방침"
    >
      <RenderHtml htmlString={qnaPolicyHtml} />
    </PolicyModal>
  );
};
